import type { OrganizationPopoverProps } from "./organization-popover.type";

import { Popover } from "antd";
import { useLocation } from "react-router";

import { OrganizationPopoverContent } from "./organization-popover-content";
import { useOrganizationPopoverZindex } from "./organization-popover.hook";

import "./organization-popover.style.less";

export const OrganizationPopover = ({
  organization,
  trigger,
  children,
  ...options
}: OrganizationPopoverProps) => {
  const { pathname } = useLocation();
  const zIndex = useOrganizationPopoverZindex(options);

  return (
    <Popover
      key={pathname} // auto close popover on internal link click
      title={organization.name}
      content={<OrganizationPopoverContent organization={organization} />}
      trigger={trigger}
      zIndex={zIndex}
      classNames={{
        root: "organization-popover",
        container: "organization-popover-container",
        title: "organization-popover-title",
      }}
    >
      <div className="organization-popover-target">{children}</div>
    </Popover>
  );
};
